import { formatMoney } from './amount'
import { computeOwed, isPartiallyCollected } from './partialPayment'

export const resolvePortalPaymentStatus = (payment) => {
  if (payment?.settledByPayment) {
    return { label: 'Paid', note: 'Covered by your online payment', tone: 'success' }
  }

  const label = payment?.status?.label || 'Scheduled'

  if (payment?.isLinkPayment) {
    return { label, note: 'Your one-time online payment', tone: 'status' }
  }

  // WS 2074858. A declined payment billing rescheduled: what is owed is the new row in Upcoming.
  if (payment?.isRescheduled) {
    return { label, note: 'Rescheduled to a new date', tone: 'status' }
  }

  const partial = isPartiallyCollected({ ...payment, status: payment?.status?.value })
  const note = partial
    ? `${formatMoney(computeOwed(payment))} of ${formatMoney(payment?.amount || 0)} still due`
    : null

  return { label, note, tone: 'status' }
}
